<template>
  <el-row :gutter="15">
    <el-col :span="12">
      <p>
        <b>Age</b><br>
        {{ ($props.account.started || $props.account.date_created) | moment('from', 'now', true) }}
      </p>

      <p>
        <b>Contact</b><br>
        {{ $props.account.contact || '-' }}
      </p>

      <p>
        <b>Address</b><br>
        <DisplayAddress
          :lines="[ $props.account.address, $props.account.suburb ]"
          :locality="$props.account.state"
          :postal-code="$props.account.postcode"
          country="AU"
        />
      </p>

      <p>
        <b>Parent Account</b><br>
        <router-link
          v-if="account.parent"
          :to="{ name: 'customerservice-accounts-account', params: { accountId: account.parent.id } }"
        >
          {{ account.parent.name }}
        </router-link>

        <template v-else>
          -
        </template>
      </p>
    </el-col>

    <el-col :span="12">
      <p>
        <b>Email</b><br>
        <a :href="`mailto:${$props.account.email}`">{{ $props.account.email || '-' }}</a>
      </p>

      <p>
        <b>Telephone</b><br>
        <a :href="`tel:${$props.account.phone}`">{{ $props.account.phone || '-' }}</a>
      </p>

      <p>
        <b>Fax</b><br>
        <a :href="`fax:${$props.account.fax}`">{{ $props.account.fax || '-' }}</a>
      </p>
    </el-col>
  </el-row>
</template>

<script>
import DisplayAddress from '@/components/Address'

export default {
  components: {
    DisplayAddress
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  }
}
</script>
